export const CP_STORE_SELECTOR = 'CP_STORE_SELECTOR';

export const CP_STORE_SELECTOR_SUCCESS = 'CP_STORE_SELECTOR_SUCCESS';

export const CP_STORE_SELECTOR_FAILED = 'CP_STORE_SELECTOR_FAILED';